export default __webpack_public_path__ + "static/media/seconedscreen.eab08ccd.png";